export default {
  // 標題
  currencyTokenContract: "幣種/代幣合約：",
  label: "標籤：",
  time: "時間：",
  functionSwitch: "功能開關：",
  sameTimeSameIP: "同時段同IP",

  // 選項
  all: "全部",
  pleaseSelect: "請選擇",

  // 日期選擇器
  startDate: "開始日期",
  endDate: "結束日期",

  // 功能開關選項
  surveyData: "調證數據",
  firstInflow: "首筆流入",

  // 功能開關提示
  surveyDataTooltip: "可擴展出已上傳調證的相關數據",
  firstInflowTooltip: "擴展增加顯示首筆主幣流入地址",

  // 標籤提示
  exchangeUserAddressTooltip: "擴展地址只顯示交易所相關標籤的地址",
  maliceTypeTooltip: "擴展地址只顯示惡意標籤的地址",

  // 成功消息
  currencyModifiedSuccess: "幣種修改成功",
  labelModifiedSuccess: "標籤修改成功",
  timeModifiedSuccess: "時間修改成功",
  switchModifiedSuccess: "開關修改成功",
};
